var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconArchive = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 24,
  height: 24,
  fill: "rgba(0,0,0,0)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "b",
  opacity: 1,
  d: "M6,7V9H18V7ZM5,11H6v7a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V11h1a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H5A1,1,0,0,0,4,6v4A1,1,0,0,0,5,11Zm3,6V11h8v6Zm3-5a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z",
  fill: "currentColor",
  fillRule: "evenodd"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArchive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-archive.2992a8a2.svg";
export { ForwardRef as ReactComponent };